import { useQuery } from '@tanstack/react-query';

import { getLibrary } from '@/requests/library/getLibrary';

import type { LibraryItem } from '@/types';

type UseLibraryQueryParams = {
  tagId: string | undefined;
};

const useLibraryQuery = ({ tagId }: UseLibraryQueryParams) => {
  return useQuery<LibraryItem[] | null>({
    queryKey: ['library', tagId],
    queryFn: async () => {
      if (!tagId) return null;
      const libraryData = await getLibrary({ tagId });
      return libraryData;
    },
    enabled: !!tagId,
    // Cache for 5 minutes to prevent duplicate requests when switching tabs
    staleTime: 5 * 60 * 1000,
    // Keep in cache for 10 minutes
    gcTime: 10 * 60 * 1000,
  });
};

export { useLibraryQuery };
